// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDTAResponsePrepopulationMetadata
 */
export interface CreateDTAResponsePrepopulationMetadata {
    /**
     * 
     * @type {string}
     * @memberof CreateDTAResponsePrepopulationMetadata
     */
    bedrock_model?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDTAResponsePrepopulationMetadata
     */
    bedrock_used?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDTAResponsePrepopulationMetadata
     */
    matched_historical_dta_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDTAResponsePrepopulationMetadata
     */
    prepopulation_pending?: boolean;
}

/**
 * Check if a given object implements the CreateDTAResponsePrepopulationMetadata interface.
 */
export function instanceOfCreateDTAResponsePrepopulationMetadata(value: object): value is CreateDTAResponsePrepopulationMetadata {
    return true;
}

export function CreateDTAResponsePrepopulationMetadataFromJSON(json: any): CreateDTAResponsePrepopulationMetadata {
    return CreateDTAResponsePrepopulationMetadataFromJSONTyped(json, false);
}

export function CreateDTAResponsePrepopulationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDTAResponsePrepopulationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'bedrock_model': json['bedrock_model'] == null ? undefined : json['bedrock_model'],
        'bedrock_used': json['bedrock_used'] == null ? undefined : json['bedrock_used'],
        'matched_historical_dta_count': json['matched_historical_dta_count'] == null ? undefined : json['matched_historical_dta_count'],
        'prepopulation_pending': json['prepopulation_pending'] == null ? undefined : json['prepopulation_pending'],
    };
}

export function CreateDTAResponsePrepopulationMetadataToJSON(json: any): CreateDTAResponsePrepopulationMetadata {
    return CreateDTAResponsePrepopulationMetadataToJSONTyped(json, false);
}

export function CreateDTAResponsePrepopulationMetadataToJSONTyped(value?: CreateDTAResponsePrepopulationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bedrock_model': value['bedrock_model'],
        'bedrock_used': value['bedrock_used'],
        'matched_historical_dta_count': value['matched_historical_dta_count'],
        'prepopulation_pending': value['prepopulation_pending'],
    };
}
